(function () {
  'use strict';

  var configElement = document.getElementById('hypest-sentry-config');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  if (!config.enabled || !config.dsn || !config.sdkUrl) return;

  var started = false;
  var sentryInitialized = false;
  var consentFeaturesAdded = false;
  var queuedErrors = [];
  var errorListener;
  var rejectionListener;

  function essentialOnly() {
    return !analyticsAllowed();
  }

  function stripSensitiveUrl(value) {
    if (!value || typeof value !== 'string') return value;

    try {
      var url = new URL(value, window.location.origin);
      return url.origin + url.pathname;
    } catch (error) {
      return value.split('?')[0].split('#')[0];
    }
  }

  function scrubEvent(event) {
    if (!event) return event;

    if (event.exception && Array.isArray(event.exception.values)) {
      for (var e = 0; e < event.exception.values.length; e++) {
        var exc = event.exception.values[e];
        if (!exc) continue;
        if (exc.value === 'Onbekende browserfout' || exc.value === 'Onbekende promise-fout') {
          return null;
        }
        if (shouldIgnoreError(exc.value, '') || exceptionHasDeniedFrame(exc)) {
          return null;
        }
      }
    }

    delete event.user;

    if (event.request) {
      event.request.url = stripSensitiveUrl(event.request.url);
      delete event.request.cookies;
      delete event.request.data;
      delete event.request.headers;
      delete event.request.query_string;
    }

    if (Array.isArray(event.breadcrumbs)) {
      event.breadcrumbs = event.breadcrumbs.map(function (breadcrumb) {
        if (breadcrumb && breadcrumb.data) {
          if (breadcrumb.data.url) breadcrumb.data.url = stripSensitiveUrl(breadcrumb.data.url);
          delete breadcrumb.data.request_body_size;
          delete breadcrumb.data.response_body_size;
        }
        return breadcrumb;
      });
    }

    return event;
  }

  function shouldDropBreadcrumb(breadcrumb) {
    if (!breadcrumb) return false;

    if (breadcrumb.category === 'console' && breadcrumb.level !== 'error') return true;

    if (breadcrumb.data && breadcrumb.data.url) {
      breadcrumb.data.url = stripSensitiveUrl(breadcrumb.data.url);
    }

    return false;
  }

  function captureQueuedErrors() {
    if (!window.Sentry || typeof window.Sentry.captureException !== 'function') return;

    queuedErrors.forEach(function (item) {
      window.Sentry.withScope(function (scope) {
        scope.setTag('captured_before_sdk', 'true');
        scope.setExtra('source', item.source);
        window.Sentry.captureException(item.error);
      });
    });
    queuedErrors = [];
  }

  var denyUrls = [
    /cdn\.shopify\.com\/shopifycloud\//i,
    /cdn[./]shopifycloud\//i,
    /shopify-perf-kit/i,
    /web-pixels\//i,
    /connect\.facebook\.net/i,
    /static\.klaviyo\.com/i,
    /product-image-hover-effect/i,
    /paypal\.com/i,
    /paypalobjects\.com/i,
    /inshop\//i,
    /omnisnippet/i,
    /pagefly/i
  ];

  var ignoreErrors = [
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded',
    'Non-Error promise rejection captured',
    'Network request failed',
    'Failed to fetch',
    'Load failed',
    'Failed to load bugsnag',
    'Script error.',
    'Onbekende browserfout',
    'Onbekende promise-fout',
    "Failed to execute 'json' on 'Response'",
    'Unexpected end of JSON input',
    'unexpected end of data',
    'The string did not match the expected pattern',
    'Window did not load after',
    'Error producing to the Monorail Edge',
    'kErrorDropped',
    "Cannot read properties of null (reading 'postMessage')",
    'Cannot read properties of null (reading "postMessage")',
    'Cannot read properties of null',
    "null is not an object (evaluating 'postMessage')",
    'null is not an object',
    "Failed to execute 'importScripts' on 'WorkerGlobalScope'",
    '/web-pixels/',
    'Object Not Found Matching Id:',
    'MethodName:update, ParamCount:',
    "Cannot destructure property 'tabId' from null or undefined value",
    'Importing a module script failed',
    'lowDisruption.refreshThePage',
    'lowDisruption.refreshThePage.set',
    't.entries.at is not a function',
    '.at is not a function'
  ];

  function isDeniedUrl(value) {
    if (!value || typeof value !== 'string') return false;
    for (var j = 0; j < denyUrls.length; j++) {
      var urlPattern = denyUrls[j];
      if (urlPattern instanceof RegExp && urlPattern.test(value)) return true;
      if (typeof urlPattern === 'string' && value.indexOf(urlPattern) !== -1) return true;
    }
    return false;
  }

  function exceptionHasDeniedFrame(exc) {
    var frames = exc && exc.stacktrace && exc.stacktrace.frames;
    if (!frames || !frames.length) return false;
    for (var f = 0; f < frames.length; f++) {
      var frame = frames[f] || {};
      if (isDeniedUrl(frame.filename) || isDeniedUrl(frame.abs_path) || isDeniedUrl(frame.absPath)) {
        return true;
      }
    }
    return false;
  }

  function shouldIgnoreError(errorOrMessage, filename) {
    if (!errorOrMessage) return true;
    var message = typeof errorOrMessage === 'string'
      ? errorOrMessage
      : (errorOrMessage && errorOrMessage.message) || String(errorOrMessage || '');

    if (!message || message === 'Onbekende browserfout' || message === 'Onbekende promise-fout') {
      return true;
    }

    for (var i = 0; i < ignoreErrors.length; i++) {
      var pattern = ignoreErrors[i];
      if (typeof pattern === 'string' && message.indexOf(pattern) !== -1) return true;
      if (pattern instanceof RegExp && pattern.test(message)) return true;
    }

    if (isDeniedUrl(filename)) return true;
    if (isDeniedUrl(message)) return true;
    var stack = errorOrMessage && errorOrMessage.stack;
    if (typeof stack === 'string' && isDeniedUrl(stack)) return true;

    return false;
  }

  function isResourceTarget(target) {
    return Boolean(
      target &&
      target !== window &&
      (target.nodeType || target.tagName || (typeof target.nodeName === 'string' && target.nodeName !== '#document'))
    );
  }

  function removeEarlyListeners() {
    if (errorListener) {
      window.removeEventListener('error', errorListener);
      window.removeEventListener('error', errorListener, true);
    }
    if (rejectionListener) {
      window.removeEventListener('unhandledrejection', rejectionListener);
      window.removeEventListener('unhandledrejection', rejectionListener, true);
    }
  }

  function replayIntegration() {
    return window.Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
      block: [
        '[data-customer-id]',
        '[data-customer-email]',
        '[data-sentry-block]',
        '.shopify-payment-button',
        'form[action*="/account"]',
        'form[action*="/contact"]',
        'form[action*="/cart"]',
        'form[action*="/checkout"]'
      ],
      ignore: ['input', 'textarea', 'select', '[contenteditable="true"]'],
      beforeAddRecordingEvent: function (event) {
        if (!event || !event.data) return event;
        var data = event.data.payload && event.data.payload.data;
        if (data && data.url) data.url = stripSensitiveUrl(data.url);
        return event;
      }
    });
  }

  function feedbackIntegration() {
    return window.Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: 'light',
      showName: false,
      showEmail: false,
      isNameRequired: false,
      isEmailRequired: false,
      showBranding: false,
      formTitle: config.feedback.formTitle,
      messageLabel: config.feedback.messageLabel,
      messagePlaceholder: config.feedback.messagePlaceholder,
      submitButtonLabel: config.feedback.submitButtonLabel,
      cancelButtonLabel: config.feedback.cancelButtonLabel,
      successMessageText: config.feedback.successMessageText,
      triggerLabel: config.feedback.triggerLabel,
      tags: { surface: 'shopify-storefront', locale: config.locale },
      themeLight: {
        background: '#FBF8F2', foreground: '#2D2D2D', accentBackground: '#4F1C24',
        accentForeground: '#F8DCE2', border: '#D8C9BE', successColor: '#4F1C24', errorColor: '#C13E48'
      }
    });
  }

  function consentIntegrations() {
    return [
      window.Sentry.browserTracingIntegration(),
      replayIntegration(),
      feedbackIntegration()
    ];
  }

  function consentUpgradeIntegrations() {
    var integrations = [];
    if (!hasIntegration('BrowserTracing')) integrations.push(window.Sentry.browserTracingIntegration());
    if (!hasIntegration('Replay')) integrations.push(replayIntegration());
    if (!hasIntegration('Feedback')) integrations.push(feedbackIntegration());
    return integrations;
  }

  function awaitFeedbackSend(feedbackResult) {
    if (feedbackResult && typeof feedbackResult.then === 'function') return feedbackResult;
    return typeof window.Sentry.flush === 'function' ? window.Sentry.flush(5000) : Promise.resolve(true);
  }

  function attachFeedback() {
    var feedbackButton = document.querySelector('[data-hypest-sentry-feedback]');
    var feedbackDialog = document.querySelector('[data-hypest-sentry-feedback-dialog]');
    var feedbackForm = document.querySelector('[data-hypest-sentry-feedback-form]');
    var feedbackMessage = document.querySelector('[data-hypest-sentry-feedback-message]');
    var feedbackCancel = document.querySelector('[data-hypest-sentry-feedback-cancel]');
    var feedbackSuccess = document.querySelector('[data-hypest-sentry-feedback-success]');

    if (!feedbackButton || !feedbackDialog || !feedbackForm || typeof window.Sentry.captureFeedback !== 'function') return;
    if (feedbackButton.dataset.hypestSentryFeedbackReady === 'true') return;

    feedbackButton.dataset.hypestSentryFeedbackReady = 'true';
    feedbackButton.hidden = false;
    feedbackButton.addEventListener('click', function () {
      feedbackSuccess.hidden = true;
      feedbackForm.hidden = false;
      feedbackDialog.showModal();
      feedbackMessage.focus();
    });
    feedbackCancel.addEventListener('click', function () {
      feedbackDialog.close();
    });
    feedbackForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var message = feedbackMessage.value.trim();
      if (!message) return;

      var submitButton = feedbackForm.querySelector('[data-hypest-sentry-feedback-submit]');
      submitButton.disabled = true;
      awaitFeedbackSend(window.Sentry.captureFeedback({
        message: message,
        associatedEventId: typeof window.Sentry.lastEventId === 'function' ? window.Sentry.lastEventId() : undefined
      }, {
        captureContext: {
          tags: { surface: 'shopify-storefront', locale: config.locale }
        }
      })).then(function (sent) {
        if (sent === false) return;
        feedbackMessage.value = '';
        feedbackForm.hidden = true;
        feedbackSuccess.hidden = false;
      }).catch(function (error) {
        window.Sentry.captureException(error, { tags: { surface: 'shopify-storefront-feedback' } });
      }).finally(function () {
        submitButton.disabled = false;
      });
    });
  }

  function initSentry() {
    if (sentryInitialized || !window.Sentry || typeof window.Sentry.init !== 'function') return;
    sentryInitialized = true;

    var limitedToEssentialErrors = essentialOnly();
    var integrations = limitedToEssentialErrors ? [] : consentIntegrations();

    window.Sentry.init({
      dsn: config.dsn,
      environment: 'production',
      release: config.release,
      dist: config.dist,
      integrations: integrations,
      sendDefaultPii: false,
      dataCollection: {
        userInfo: false,
        cookies: false,
        httpHeaders: {
          request: false,
          response: false
        },
        httpBodies: [],
        urlQueryParams: false
      },
      attachStacktrace: true,
      enableLogs: !limitedToEssentialErrors,
      tracesSampleRate: limitedToEssentialErrors ? 0 : 0.1,
      replaysSessionSampleRate: limitedToEssentialErrors ? 0 : 0.01,
      replaysOnErrorSampleRate: limitedToEssentialErrors ? 0 : 1.0,
      tracePropagationTargets: [
        /^https:\/\/(www\.)?hypestofficial\.com\//,
        /^\//
      ],
      beforeSend: scrubEvent,
      beforeSendTransaction: scrubEvent,
      beforeBreadcrumb: function (breadcrumb) {
        return shouldDropBreadcrumb(breadcrumb) ? null : breadcrumb;
      },
      denyUrls: denyUrls,
      ignoreErrors: ignoreErrors,
      initialScope: {
        tags: {
          surface: 'shopify-storefront',
          page_type: config.pageType,
          template: config.template,
          locale: config.locale,
          currency: config.currency,
          theme_id: config.themeId
        }
      }
    });

    window.Sentry.setContext('shopify', {
      shop: config.shop,
      page_type: config.pageType,
      template: config.template,
      locale: config.locale,
      currency: config.currency,
      theme_id: config.themeId,
      theme_role: config.themeRole
    });

    if (!limitedToEssentialErrors && window.Sentry.metrics && typeof window.Sentry.metrics.count === 'function') {
      window.Sentry.metrics.count('hypest.storefront.page_view', 1, {
        attributes: {
          page_type: config.pageType,
          locale: config.locale
        }
      });
    }

    if (!limitedToEssentialErrors && window.Sentry.logger && typeof window.Sentry.logger.info === 'function') {
      window.Sentry.logger.info('HYPEST storefront monitoring started', {
        page_type: config.pageType,
        locale: config.locale,
        theme_id: config.themeId
      });
    }

    if (!limitedToEssentialErrors) attachFeedback();

    captureQueuedErrors();
    removeEarlyListeners();

    window.HypestSentry = {
      captureException: function (error, context) {
        window.Sentry.withScope(function (scope) {
          if (context) scope.setContext('hypest', context);
          window.Sentry.captureException(error);
        });
      },
      captureMessage: function (message, context) {
        window.Sentry.withScope(function (scope) {
          if (context) scope.setContext('hypest', context);
          window.Sentry.captureMessage(message);
        });
      },
      startSpan: window.Sentry.startSpan,
      metric: window.Sentry.metrics
    };
  }

  function loadSentry() {
    if (started || !config.sdkUrl) return;
    started = true;

    function startAfterLoad() {
      if (window.Sentry && typeof window.Sentry.init === 'function') initSentry();
    }

    if (window.Sentry && typeof window.Sentry.init === 'function') {
      startAfterLoad();
      return;
    }

    function injectSdk() {
      var script = document.createElement('script');
      script.src = config.sdkUrl;
      script.crossOrigin = 'anonymous';
      script.referrerPolicy = 'strict-origin';
      script.async = true;
      script.setAttribute('data-hypest-sentry-sdk', '');
      script.onload = startAfterLoad;
      script.onerror = function () {
        started = false;
      };
      document.head.appendChild(script);
    }

    /* Snelheid telefoon Keuze 1 punt 5 (2026-10-06): de Sentry-bibliotheek (~94 KB) pas ná het laden
       van de pagina ophalen (en niet in de eerste 4 s na 'Alles accepteren', zodat Meta voorgaat).
       Fouten van vóór dat moment staan in queuedErrors en worden daarna alsnog gemeld. */
    if (typeof window.hypestAfterLoad === 'function') window.hypestAfterLoad(injectSdk, 0);
    else injectSdk();
  }

  function analyticsAllowed() {
    return Boolean(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
      window.Shopify.customerPrivacy.analyticsProcessingAllowed()
    );
  }

  function hasIntegration(name) {
    var client = typeof window.Sentry.getClient === 'function' ? window.Sentry.getClient() : null;
    return Boolean(client && typeof client.getIntegrationByName === 'function' && client.getIntegrationByName(name));
  }

  function enableConsentFeatures() {
    if (!started || !analyticsAllowed() || !window.Sentry) return;
    if (consentFeaturesAdded || (window.HypestSentry && window.HypestSentry.consentFeaturesEnabled)) return;

    var client = typeof window.Sentry.getClient === 'function' ? window.Sentry.getClient() : null;
    if (!client || typeof window.Sentry.addIntegration !== 'function') return;
    consentFeaturesAdded = true;
    var integrations = consentUpgradeIntegrations();

    var options = client.getOptions();
    options.tracesSampleRate = 0.1;
    options.replaysSessionSampleRate = 0.01;
    options.replaysOnErrorSampleRate = 1.0;
    options.enableLogs = true;

    integrations.forEach(function (integration) {
      if (!hasIntegration(integration.name)) window.Sentry.addIntegration(integration);
    });
    attachFeedback();
    if (window.HypestSentry) window.HypestSentry.consentFeaturesEnabled = true;
  }

  function loadWhenAllowed() {
    if (!analyticsAllowed()) return;
    if (started) {
      enableConsentFeatures();
    } else {
      loadSentry();
    }
  }

  function loadForEssentialErrorMonitoring() {
    if (started || analyticsAllowed()) return;
    loadSentry();
  }

  errorListener = function (event) {
    if (!event) return;
    if (isResourceTarget(event.target)) return;

    var rawError = event.error;
    var message = event.message || (rawError && rawError.message);
    if (!rawError && !message) return;

    var filename = event.filename || '';
    if (shouldIgnoreError(rawError || message, filename)) return;

    queuedErrors.push({
      source: filename || 'window.error',
      error: rawError || new Error(message)
    });
    if (queuedErrors.length > 20) queuedErrors.shift();
    loadForEssentialErrorMonitoring();
  };

  rejectionListener = function (event) {
    if (!event) return;
    var reason = event.reason;
    if (!reason) return;

    if (shouldIgnoreError(reason, '')) return;

    queuedErrors.push({
      source: 'unhandledrejection',
      error: reason instanceof Error ? reason : new Error(String(reason))
    });
    if (queuedErrors.length > 20) queuedErrors.shift();
    loadForEssentialErrorMonitoring();
  };

  window.addEventListener('error', errorListener);
  window.addEventListener('unhandledrejection', rejectionListener);
  document.addEventListener('visitorConsentCollected', loadWhenAllowed);
  document.addEventListener('trackingConsentAccepted', loadWhenAllowed);

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) loadWhenAllowed();
      }
    );
  }

  loadWhenAllowed();
  window.setTimeout(loadWhenAllowed, 1500);
})();
